export const MAX_HEIC_PIXELS = 40_000_000;
export const MAX_HEIC_BYTES = 50 * 1024 * 1024;
export const HEIF_EXTENSIONS = ['.heic', '.heif'];

export const extensionOf = (file: File): string => file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

export const isHeifFile = (file: File): boolean =>
  file.type === 'image/heic' || file.type === 'image/heif' || HEIF_EXTENSIONS.includes(extensionOf(file));
